/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { firebase } from '../../firebase';

const state = {
  data: [],
  loading: false,
};
const getters = {};
const actions = {
  fetchOrgs({ dispatch, commit }) {
    dispatch('setLoading', true);
    commit('FETCH_ORGS');
    dispatch('setLoading', false);
  },
  setLoading({ commit }, data) {
    commit('SET_LOADING_ORG', data);
  },
};

const mutations = {
  SET_LOADING_ORG(state, data) {
    state.loading = data;
  },
  async FETCH_ORGS(state) {
    const dataRef = firebase.firestore().collection('organisations');
    const user = this.state.account.user.uid;
    const snapshot = await dataRef.where('administrators', 'array-contains', user).get();

    if (snapshot.empty) {
      console.log('No matching documents.');
      return;
    }

    // Add the data from the firestore to the vuex.
    snapshot.forEach((doc) => {
      const docData = doc.data();
      const docID = doc.id;

      state.data.push({
        docID,
        docData,
      });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
